// Where ✕ on settings, the account and the create page goes (SPEC §4.3; plan
// 2026-11-04-navigation-return.md §3.1, §3.5): back in the browser's history to the last page
// before the player entered these pages, so that the page underneath comes back as it was and the
// back button afterwards doesn't return to them; the game list when there is no such page in this
// visit (opened from a link, or after a reload).

// The pages that ✕ closes.
export const CLOSABLE = ['settings', 'account', 'create-game'];

// How many history entries the player has gone forward since leaving the last other page; 0 when
// it isn't known.
let depth = 0;
// Set by the browser's back and forward buttons just before the router handles them.
let popped = false;
let router = null;

// Called by main.js before the app is mounted, so that this popstate listener runs before the
// router's own. (The router is passed in: importing it here would be circular, since it imports
// the pages that use closePage.)
export function installNavigation(r) {
  router = r;
  window.addEventListener('popstate', () => { popped = true; });
  router.afterEach(track);
}

function track(to, from) {
  const wasPop = popped;
  popped = false;
  const inside = CLOSABLE.includes(to.name);
  const fromInside = CLOSABLE.includes(from.name);
  // The first page shown: nothing to go back to.
  if (!from.name) { depth = 0; return; }
  if (!inside) { depth = 0; return; }
  if (!fromInside) { depth = 1; return; }
  // Between the closable pages: forward adds an entry, back removes one.
  if (!wasPop) depth += 1;
  else depth = Math.max(0, depth - 1);
}

// Leaves the closable pages.
export function closePage() {
  if (depth > 0) {
    const n = depth;
    depth = 0;
    router.go(-n);
  } else {
    router.push({ name: 'list' });
  }
}
